module.exports = __webpack_public_path__ + "static/media/ChevronRight.4cb2bc69.svg";